import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getTotalBudgetDepletedProgressBarStyles } from '../styles';

export const TotalBudgetDepletedProgressBar = ({
  percentage,
}) => {
  const classes = useDefaultStyles(getTotalBudgetDepletedProgressBarStyles, { percentage });

  return (
    <div className={classnames('total-budget-depleted-progress-bar', classes.Container)} data-percentage={percentage}>
      <div className={classnames('total-budget-depleted-progress-bar-bar', classes.Bar)} />
      <div className={classnames('total-budget-depleted-progress-bar-separator', classes.Separator)} />
    </div>
  );
};

TotalBudgetDepletedProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
};
